module.exports = __webpack_public_path__ + "static/media/letter-footer.690f9021.svg";